suppress ALL

<template>
	<tr>
		<td class="text-xs-center">
			{{user.name }}
		</td>
		<td class="text-xs-center">
			{{user.last_name }}
		</td>
		<td class="text-xs-right">
			{{user.username }}
		</td>
		<td class="text-xs-right">
			{{user.company && user.company.name }}
		</td>
		<td v-if="showOrganization">
			{{user.organizations_name}}
		</td>
		<td>
			<edit-btn @click="onEdit" class="mx-2 my-1"/>
			<remove-btn @remove="doRemove" class="mx-2 my-1"/>
			<v-btn v-if="isAdmin" @click="loginAs" color="primary" :loading="loading">כנס כמשתמש</v-btn>
		</td>

	</tr>
</template>

<script>

	import {types} from "src/store/modules/User.module";
	import RemoveBtn from "src/scaffoldings/RemoveBtn";
	import EditBtn from "src/scaffoldings/EditBtn";
	import RowMixin from "src/mixins/RowMixin";
	import AuthService from "dev/packages/AuthService";

	export default {
		name: "user-row",
		props: {
			user: {required: true},
			showOrganization: {default: false}
		},
		components: {EditBtn, RemoveBtn},
		mixins: [new RowMixin(types, "user")],
		data() {
			return {
				loading: false
			};
		},
		computed: {
			isAdmin() {
				return this.$store.getters.isAdmin;
			}
		},
		methods: {
			async loginAs() {
				this.loading = true;
				await AuthService.loginAs(this.user.id);
				window.location.replace("/");
			},
			doRemove() {
				this.$store.dispatch(types.REMOVE, this.user);
			},
			onEdit() {
				this.$emit("edit", this.user);
			}
		}
	};
</script>

<style>

</style>
